import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const statusChipVariants = cva("status-chip", {
  variants: {
    status: {
      active:    "status-chip-active",
      pending:   "status-chip-pending",
      inactive:  "status-chip-inactive",
      published: "status-chip-published",
      draft:     "status-chip-draft",
    },
  },
  defaultVariants: { status: "draft" },
});

const LABELS: Record<string, string> = {
  active:    "Active",
  pending:   "Pending",
  inactive:  "Inactive",
  published: "Published",
  draft:     "Draft",
};

interface StatusChipProps extends VariantProps<typeof statusChipVariants> {
  className?: string;
}

export function StatusChip({ status, className }: StatusChipProps) {
  return (
    <span className={cn(statusChipVariants({ status }), className)}>
      {LABELS[status ?? "draft"]}
    </span>
  );
}
